import React from 'react';
import proptypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import { getCreativeId } from '../../utils/helpers';

const { string, bool, shape, object } = proptypes;

const SponsoredUniversalBannerCreative = ({
  schemaId,
  showBanner,
  bannerType,
  data
}) => {

  const { ref, clickID } = useImpression({
    data: {
      id: '00DEFVALSPB00',
      name: bannerType,
      component: 'SponsoredUniversalBanner',
      type: 'sponsoredcontent',
      campaignId: data?.sponsored?.banner?.campaignId,
      slotId: data?.sponsored?.banner?.slotId?.toString(),
      placementId: data?.sponsored?.banner?.placementId,
      flightId: data?.sponsored?.banner?.flightId,
      sponsoredId: data?.sponsored?.banner?.adRequestId,
      creativeId: getCreativeId(data?.sponsored?.banner?.bannerURL),
      category: '',
      position: 2,
    }
  });
  return (
    <div>
      {
        showBanner && (
          <div
            ref={ref} // eslint-disable-next-line react/no-unknown-property
            clickid={clickID}
            id={schemaId}
            data-testid={`sponsored-${bannerType}-banner`}
            className={`sponsored_${bannerType}_banner`}
            data-ubc="true"
          />
        )
      }
    </div>
  );
};

const propTypes = {
  schemaId: string,
  bannerType: string,
  showBanner: bool,
  data: shape({
    sponsored: shape({
      banner: shape({
        campaignId: string,
        slotId: string,
        placementId: string,
        flightId: string,
        adRequestId: string,
        bannerURL: string,
      }),
    }),
  }),
};

const defaultProps = {
  schemaId: '',
  bannerType: '',
  showBanner: false,
  data: {
    sponsored: {
      banner: {
        campaignId: '',
        slotId: '',
        placementId: '',
        flightId: '',
        adRequestId: '',
        bannerURL: '',
      },
    },
  },
};

SponsoredUniversalBannerCreative.propTypes = propTypes;
SponsoredUniversalBannerCreative.defaultProps = defaultProps;

export { SponsoredUniversalBannerCreative };
